import { render } from "./DrillHoleEdges.vue?vue&type=template&id=662def84"
import script from "./DrillHoleEdges.vue?vue&type=script&lang=js"
export * from "./DrillHoleEdges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__